export const SHOW_RESULTS_OPTIONS = [
  { label: "10 / Page", value: 10 },
  { label: "25 / Page", value: 25 },
  { label: "50 / Page", value: 50 },
  { label: "75 / Page", value: 75 },
  { label: "100 / Page", value: 100 },
  { label: "200 / Page", value: 200 },
];

export const DATE_FORMAT = [
  { label: "DD/MM/YYYY", value: "date-month-year" },
  { label: "MM/DD/YYYY", value: "month-date-year" },
  { label: "YYYY/MM/DD", value: "year-month-date" },
];
